<div class="org-list-box">
    <div>
        <input type="text" placeholder="search..." (input)="searchChanged($event.target.value)" />
    </div>
    <div class="org-list">
        <table>
            <tbody>
                <tr *ngFor="let org of organizations" [ngClass]="{'expanded': org.expanded, 'selected': org.selected }" (click)="onOrgSelect(org)">
                    <td>{{org.orgName}}</td>
                    <td>{{(org.isActive===true)?"Active":"Inactive"}}</td>
                    <td>
                        <a (click)="onOrgExpandOrCollapse(org)">
                            <span *ngIf="!org.expanded">(+)</span><span *ngIf="org.expanded">(-)</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>